import React, { FC, memo, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';


type AlarmType = {
  id: string | number;
  type: string;
  title: string;
  date: string;
  link: string;
}

interface IAlarmPopupProps {
  isVisible: boolean;
  data: {
    [key: string]: AlarmType[];
  };
}

 const AlarmPopup: FC<IAlarmPopupProps> = ({ isVisible, data }) => {
  const ref = useRef(null);
  const isEmptyData = !data || Object.keys(data).length === 0;

  return (
    <div
      ref={ref}
      className={`alarm-popup-menu dropdown-menu-lg dropdown-menu-right
      ${isVisible ? 'show' : ''}
    `} >
      <div className='alarm-popup-wrap'>
        {
          isEmptyData
            ? (
              <dl>
                <dt>System</dt>
                <dd>
                  <span className="badge-text">Empty</span>
                  <a href={`#`} className="tit">알림이 없습니다.</a>
                </dd>
              </dl>
            )
            : (
              <>
                {
                  Object.keys(data).map((date, index) => {
                    return (
                      <dl key={`alarm-${date}-index`}>
                        <dt>{date}</dt>
                        {
                          data[date].map(alarm => {
                            return (
                              <dd>
                                <span className="badge-text">{alarm.type}</span>
                                <Link to={{ pathname:`${alarm.link}/${alarm.id}`, state: { link: alarm.link }}} className="tit">{alarm.title}</Link>
                              </dd>
                            )
                          })
                        }
                      </dl>
                    )
                  })
                }
              </>
            )
        }
      </div>
  </div>
  );
}
export default memo(AlarmPopup);